import { TrailCircle, Vector2D } from '@/types';

export class TrailCirclePool {
  private pool: TrailCircle[] = [];

  constructor(initialSize: number = 5000) {
    for (let i = 0; i < initialSize; i++) {
      this.pool.push(this.createEmptyCircle());
    }
  }

  private createEmptyCircle(): TrailCircle {
    return {
      pos: { x: 0, y: 0 },
      radius: 0,
      hue: 0,
    };
  }

  get(pos: Vector2D, radius: number, hue: number): TrailCircle {
    let circle = this.pool.pop();
    if (!circle) {
      circle = this.createEmptyCircle();
    }

    circle.pos.x = pos.x;
    circle.pos.y = pos.y;
    circle.radius = radius;
    circle.hue = hue;
    circle.alpha = undefined;

    return circle;
  }

  release(circle: TrailCircle) {
    this.pool.push(circle);
  }

  getAvailableCount(): number {
    return this.pool.length;
  }
}
